import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const BottomSheet = ({
  showModal,
  setShowModal,
  children,
  headerText = "Modal Header",
  saveText = "Save changes",
  saveAction,
  disableBackdropClick = false,
  disableCloseButton = false,
  showFooter = true,
  cancelAction = ()=>setShowModal(false),
  showCancel, 
  cancelText = "Avbryt",
  disabled = false
}) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (showModal) {
      setAnimate(true);
    } else {
      const timer = setTimeout(() => setAnimate(false), 300); // Delay unmount
      return () => clearTimeout(timer);
    }
  }, [showModal]);

  // Only unmount after exit animation
  if (!animate && !showModal) return null;

  return (
    <>
      {/* Backdrop Overlay */}
      <div
        className={`modal-backdrop fade ${showModal ? "show" : ""}`}
        style={{ zIndex: 1050 }}
        onClick={() => !disableBackdropClick && setShowModal(false)}
      ></div>

      {/* Bottom Sheet Modal */}
      <div
        className={`modal d-block`}
        tabIndex="-1"
        role="dialog"
        style={{
          position: "fixed",
          bottom: 0,
          left: "50%",
          transform: showModal
            ? "translateX(-50%) translateY(0)"
            : "translateX(-50%) translateY(100%)",
          width: "100%",
          maxWidth: "600px",
          transition: "transform 0.3s ease-in-out",
          zIndex: 1090,
        }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content rounded-top">
            <div className="modal-header">
              <h5 className="modal-title">{headerText}</h5>
              {!disableCloseButton && (
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              )}
            </div>

            <div className="modal-body">{children}</div>
            {showFooter && (
                <div className="modal-footer d-flex justify-content-around gap-1">
                    {showCancel && (
                    <button
                        className="btn btn-secondary"
                        style={{ flex: "0 0 35%" }}
                        onClick={() => {
                          cancelAction()
                          setShowModal(false)
                        }}
                    >
                        {cancelText}
                    </button>
                    )}
                    {saveAction && (disabled ? <div>Samtliga obligatoriska fält måste fyllas i</div> :
                    <button
                        className="btn btn-warning"
                        style={{ flex: showCancel ? "0 0 55%" : "0 0 100%" }}
                        onClick={() => {
                          saveAction()
                          setShowModal(false)
                        }}
                    >
                        {saveText}
                    </button>
                    )}
                </div>
                )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BottomSheet;
